import { dimensionData } from "@/assets/traitInfo/dimensionData";
import { setCurrentRecommended } from "@/redux/slices/userSlice";
import { RootState } from "@/redux/store";
import {
  DimensionEvent,
  DimensionEventStatus,
} from "@dimensional-engineering/dimensional-models";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listUserCompletedDimensionsForGating } from "../authenticatedProfile/tabs/AuthCompareTab/PeerStories/utils";

export default function useRecommendedDimensionSlug() {
  const [slug, setSlug] = useState<string | null>("");
  const dimensionEvents: DimensionEvent[] | null = useSelector(
    (state: RootState) => state.user.dimensionEvents
  );

  const dispath = useDispatch();

  useEffect(() => {
    ///logic for what to show for the recommended dimension
    //if core dimensions aren;t finished, show next core dimension not finished
    //if core finished, show any dimension they've started by latest for cta block
    //if they have'n't started any, just show the latest in order
    const finishedSlugs = listUserCompletedDimensionsForGating(dimensionEvents);

    let core = ["personality", "personality-II", "values"];

    const primaryTraitsStatus = dimensionEvents?.find(
      (d) => d.dimensionSlug === "personality"
    )?.event;

    const primaryTraitsLongStatus = dimensionEvents?.find(
      (d) => d.dimensionSlug === "primary-traits-long"
    )?.event;

    const cognitionStatus = dimensionEvents?.find(
      (d) => d.dimensionSlug === "personality-II"
    )?.event;

    const cognitionLongStatus = dimensionEvents?.find(
      (d) => d.dimensionSlug === "cognition-long"
    )?.event;

    const valuesStatus = dimensionEvents?.find(
      (d) => d.dimensionSlug === "values"
    )?.event;

    const valuesLongStatus = dimensionEvents?.find(
      (d) => d.dimensionSlug === "values-long"
    )?.event;

    if (
      !cognitionStatus ||
      cognitionStatus === DimensionEventStatus.started ||
      cognitionLongStatus === DimensionEventStatus.started
    ) {
      setSlug("personality-II");
      dispath(setCurrentRecommended("personality-II"));
    } else if (
      !valuesStatus ||
      valuesStatus === DimensionEventStatus.started ||
      valuesLongStatus === DimensionEventStatus.started
    ) {
      dispath(setCurrentRecommended("values"));
      setSlug("values");
    } else if (
      !primaryTraitsStatus ||
      primaryTraitsStatus === DimensionEventStatus.started ||
      primaryTraitsLongStatus === DimensionEventStatus.started
    ) {
      setSlug("personality");
      dispath(setCurrentRecommended("personality"));
    } else {
      //other dimensions
      let otherDimInProgress: { slug: string; date: number | undefined }[] = [];
      dimensionEvents?.forEach((dim) => {
        if (
          !core.includes(dim.dimensionSlug) &&
          dim.event === DimensionEventStatus.started
        ) {
          otherDimInProgress.push({
            slug: dim.dimensionSlug,
            date: dim.updatedOn,
          });
        }
      });

      if (otherDimInProgress.length === 0) {
        //none of the other dimensions are in progress. We check for completion and use next one in order as the recommended
        //if it exists.
        let tempArray = [];
        for (let i = 0; i < dimensionData.length; i++) {
          if (
            !core.includes(dimensionData[i].slug) &&
            !finishedSlugs.includes(dimensionData[i].slug)
          ) {
            ///not core and not finished
            tempArray.push(dimensionData[i]);
          }
        }
        tempArray.sort((a, b) => {
          return a.order - b.order;
        });
        if (tempArray.length > 0) {
          setSlug(tempArray[0].slug);
          dispath(setCurrentRecommended(tempArray[0].slug));
        } else {
          setSlug(null);
          dispath(setCurrentRecommended(null));
        }
      } else {
        //have dimensions in progress
        otherDimInProgress.sort((a, b) => {
          if (a.date && b.date) {
            return a.date - b.date;
          } else {
            return 0;
          }
        });
        setSlug(otherDimInProgress[0].slug);
        dispath(setCurrentRecommended(otherDimInProgress[0].slug));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensionEvents]);

  return slug;
}
